module.exports = __webpack_public_path__ + "img/crm_case3.0deba350.png";